// hooks
import React, {useEffect, useState} from 'react';
import useSearchData from '../hooks/useSearchData';
// Components
import TakisHeroSkeleton from "../components/Skeletons/TakisHeroSkeleton"
import TakisRecipeListSkeleton from "../components/Skeletons/TakisRecipeListSkeleton"
import TakisGridSkeleton from '../components/Skeletons/TakisGridSkeleton';
import TakisGrid from '../components/TakisGrid';
import TakisRecipeList from '../components/TakisRecipeList';
import { useLanguage, supportedLanguages } from '../hooks/useLanguage';
import { useQueryParams } from '../hooks/useLocationData';

const Search = ({searchConfig}) => {
  const language = useLanguage()
  const [resultData, setResultData] = useState("");

  const queryParams = useQueryParams();
  const searchText = queryParams.get(searchConfig.title.toLowerCase())

  const isSpanish = language === supportedLanguages.es;
  const productGridLabelPlural = isSpanish
    ? "Productos Encontrados"
    : 'Found Products';
  const productGridLabelSingular = isSpanish
    ? "Producto Encontrado"
    : 'Found Product';
  const recipeGridLabelPlural = isSpanish
    ? "Recetas Encontradas"
    : 'Found Recipe';
  const recipeGridLabelSingular = isSpanish
    ? "Receta Encontrada"
    : 'Found Recipe';
  const productGridLabelNone = isSpanish
    ? "no hay productos para: "
    : 'no products for: ';
  const recipeGridLabelNone = isSpanish
    ? "no hay recetas para: "
    : 'no recipes for: ';

  let products
  let recipes

  const { error, isLoading, searchData } = useSearchData(searchConfig);

  useEffect(() => {
    if (searchData) {
      setResultData(searchData);
    }
  }, [searchData, language, queryParams]);

  if (isLoading || error || !resultData) {
    return (
      <>
        <TakisHeroSkeleton/>
        <TakisRecipeListSkeleton/>
        <TakisGridSkeleton/>
      </>
    );
  }

  // checks for grid content
  if (resultData?.foundProducts?.items?.length)
  {
    products =
      <TakisGrid
        title={`
          ${
            resultData.foundProducts.items.length > 1
              ? productGridLabelPlural
              : productGridLabelSingular
          }
        `}
        flattop={true}
        isSectionTitle={true}
        items={resultData.foundProducts.items}
      />
  } else {
    // No results
    products =
      <TakisGrid
        title={`${productGridLabelNone}${searchText}`}
        isSectionTitle={true}
        flattop={true}
        items={[]}
      />
  }

  if (resultData?.foundRecipes?.recipes?.length)
  {
    recipes =
      <TakisRecipeList
        title={`
          ${
            resultData.foundRecipes.recipes.length > 1
              ? recipeGridLabelPlural
              : recipeGridLabelSingular
          }
        `}
        isSectionTitle={false}
        initialRecipes={resultData.foundRecipes.recipes}
        propRecipes={resultData.foundRecipes.recipes}
        isStatic={true}
      />
  } else {
    // No results
    recipes =
      <TakisRecipeList
        title={`${recipeGridLabelNone}${searchText}`}
        isSectionTitle={false}
        isStatic={true}
        data-list="list"
      />
  }

  return (
    <>
      {products}
      {recipes}
    </>
  )

};

export default Search;
